import { useEffect, useState } from "react";
import AdminLayout from "@/components/layout/AdminLayout";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { api } from "@/lib/api";

export default function AdminCMS() {
  const [blog, setBlog] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [subs, setSubs] = useState([]);

  useEffect(() => {
    api.get("/cms/blog").then((r) => setBlog(r.data)).catch(() => {});
    api.get("/admin/contacts").then((r) => setContacts(r.data)).catch(() => {});
    api.get("/admin/subscribers").then((r) => setSubs(r.data)).catch(() => {});
  }, []);

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">CMS</div>
          <h1 className="font-display text-3xl mt-2">Content Management</h1>
        </div>
        <Tabs defaultValue="blog">
          <TabsList>
            <TabsTrigger value="blog">Blog</TabsTrigger>
            <TabsTrigger value="contacts">Contact leads</TabsTrigger>
            <TabsTrigger value="subs">Subscribers</TabsTrigger>
          </TabsList>
          <TabsContent value="blog" className="pt-4">
            <Card className="p-0 overflow-hidden">
              <Table>
                <TableHeader><TableRow><TableHead>Title</TableHead><TableHead>Slug</TableHead><TableHead>Author</TableHead><TableHead>Created</TableHead></TableRow></TableHeader>
                <TableBody>{blog.map((b) => <TableRow key={b.id}><TableCell>{b.title}</TableCell><TableCell className="text-xs">{b.slug}</TableCell><TableCell>{b.author}</TableCell><TableCell>{new Date(b.created_at).toLocaleDateString()}</TableCell></TableRow>)}</TableBody>
              </Table>
            </Card>
          </TabsContent>
          <TabsContent value="contacts" className="pt-4">
            <Card className="p-0 overflow-hidden">
              <Table>
                <TableHeader><TableRow><TableHead>Name</TableHead><TableHead>Email</TableHead><TableHead>Message</TableHead><TableHead>Received</TableHead></TableRow></TableHeader>
                <TableBody>{contacts.map((c, i) => <TableRow key={i}><TableCell>{c.name}</TableCell><TableCell>{c.email}</TableCell><TableCell className="max-w-md truncate">{c.message}</TableCell><TableCell>{new Date(c.created_at).toLocaleString()}</TableCell></TableRow>)}</TableBody>
              </Table>
            </Card>
          </TabsContent>
          <TabsContent value="subs" className="pt-4">
            <Card className="p-0 overflow-hidden">
              <Table>
                <TableHeader><TableRow><TableHead>Email</TableHead><TableHead>Since</TableHead></TableRow></TableHeader>
                <TableBody>{subs.map((s, i) => <TableRow key={i}><TableCell>{s.email}</TableCell><TableCell>{new Date(s.created_at).toLocaleDateString()}</TableCell></TableRow>)}</TableBody>
              </Table>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </AdminLayout>
  );
}
